var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8064 13.1059C23.8064 13.1059 25.1015 12.5865 24.9936 13.848C24.9576 14.3674 24.6339 16.1854 24.382 18.1518L23.5186 23.9769C23.5186 23.9769 23.4467 24.8302 22.7991 24.9786C22.1516 25.127 21.1803 24.4592 21.0004 24.3108C20.8565 24.1995 18.3023 22.5299 17.4029 21.7136C17.151 21.491 16.8632 21.0458 17.4388 20.5264L21.2162 16.8162C21.6479 16.3709 22.0796 15.3321 20.2809 16.5936L15.2444 20.1183C15.2444 20.1183 14.6688 20.4893 13.5895 20.1554L11.2511 19.4133C11.2511 19.4133 10.3877 18.8568 11.8627 18.3002C15.4602 16.5564 19.8852 14.7755 23.8064 13.1059Z",
    fill: "url(#paint0_linear_2451_52910)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2451_52910",
    x1: 11,
    y1: 19,
    x2: 25,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0387F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED4B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity2);
export default __webpack_public_path__ + "static/media/community_2.15b30070f6bafd27cebf6fc6511810b9.svg";
export { ForwardRef as ReactComponent };